import {
  databaseForCopyAndPasteContentId,
  getDatabaseForCopyAndPaste,
} from './databaseForCopyAndPaste';
import {
  databaseForCopyAndPasteWithAttachmentFieldsContentId,
  getDatabaseForCopyAndPasteWithAttachmentFields,
} from './databaseForCopyAndPasteWithAttachmentFields';
import {
  databaseWithSmallCsvStructureContentId,
  getDatabaseWithSmallCsvStructure,
} from './databaseWithSmallCsvStructure';
import {
  databaseWithSmallCsvStructureContentIdWithUgc,
  getDatabaseWithSmallCsvStructureWithUgc,
} from './databaseWithSmallCsvStructureWithUgc';
import { databaseWithViewsContentId, getDatabaseWithViews } from './databaseWithViews';
import { emptyDatabaseContentId, getEmptyDatabase } from './emptyDatabase';

export default {
  emptyDatabase: {
    database: getEmptyDatabase(),
    contentId: emptyDatabaseContentId,
  },
  databaseWithViews: {
    database: getDatabaseWithViews(),
    contentId: databaseWithViewsContentId,
  },
  databaseWithSmallCsvStructure: {
    database: getDatabaseWithSmallCsvStructure(),
    contentId: databaseWithSmallCsvStructureContentId,
  },
  databaseWithSmallCsvStructureWithUgc: {
    database: getDatabaseWithSmallCsvStructureWithUgc(),
    contentId: databaseWithSmallCsvStructureContentIdWithUgc,
  },
  databaseForCopyAndPaste: {
    database: getDatabaseForCopyAndPaste(),
    contentId: databaseForCopyAndPasteContentId,
  },
  databaseForCopyAndPasteWithAttachmentFields: {
    database: getDatabaseForCopyAndPasteWithAttachmentFields(),
    contentId: databaseForCopyAndPasteWithAttachmentFieldsContentId,
  },
};
